import { FC } from 'react';
import s from './emptyCart.module.scss';
import { Button } from '@components/UIKit/Button/Button';
import { useTranslation } from '@hooks/useTranslation';
import { useRouter } from 'next/router';
import { LinksEnum } from '@specs/navigation';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
interface Props {}
export const EmptyCart: FC<Props> = ({}) => {
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  const clickHandler = async () => {
    await router.push(LinksEnum.EXPLORE);
  };
  return <div className={s.emptyCart} data-sentry-component="EmptyCart" data-sentry-source-file="EmptyCart.tsx">
            <div className={s.emptyCart__top}>
                <div className={s.emptyCart__icon}>
                    <SpriteIcon name={'empty_cart'} colored width={'100%'} height={'100%'} data-sentry-element="SpriteIcon" data-sentry-source-file="EmptyCart.tsx" />
                </div>
                <div className={s.emptyCart__body}>
                    <div className={s.emptyCart__title}>
                        {tr({
            id: 'cart.page.your.cart.is.empty.title'
          })}
                    </div>
                    <div className={s.emptyCart__description}>
                        {tr({
            id: 'cart.page.your.cart.is.empty.description'
          })}
                    </div>
                </div>
            </div>
            <Button id='default_button' color={'Black'} size={'large'} onClick={clickHandler} data-sentry-element="Button" data-sentry-source-file="EmptyCart.tsx">
                {tr({
        id: 'btn.go.to.explore'
      })}
            </Button>
        </div>;
};